import React from "react";
import "./Loader.css"; // Use your shared CSS here

const Loader = () => {
  return (
    <div className="news-loading-wrapper">
      <div className="news-loader">
        <span className="loader-box"></span>
        <span className="loader-box"></span>
        <span className="loader-box"></span>
        <span className="loader-box"></span>
      </div>
    </div>
  );
};

export default Loader;
